import React, { useState, useEffect } from "react";
import { Image } from "react-bootstrap";
import icNext from "../../../assets/images/ic-arrow-next.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import Dots from "../../../assets/images/la-dots.svg";
import LearningModulesEditDetails from "./LearningModulesDetails";
import { useParams } from "react-router-dom";

const LearningModulesEdit = ({
  title,
  data,
}: {
  title?: string;
  data: any;
}) => {
  const params = useParams();
  const { categoryId }: any = params;

  return (
    <>
      <a
        href={
          categoryId
            ? `/learning/details/${categoryId}`
            : `/learningmodulesDetails`
        }
      >
        <b>
          VIEW ALL
          <span style={{ fontSize: "18px" }}>
            <Image
              src={icNext}
              style={{
                width: "18px",
                height: "18px",
              }}
            />
          </span>
        </b>
      </a>
      {/* <a href="/learningmodulesDetails"> <Image src={Dots} /> </a>          */}
    </>
  );
};

export default LearningModulesEdit;
